module.exports = __webpack_public_path__ + "static/media/buy_req_make_11.326021e2.jpg";